import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { designActions } from '../../actions';
import _ from 'lodash';

function CSS2JS(css) {
  if (css) {
    let frameCSS = css.replace(/([\w-.]+)\s*:([^;]+);?/g, '$1:$2,');
    frameCSS = frameCSS.replace(/,+$/, '');
    let properties = frameCSS.split(', ');
    let frameCSSObj = {};
    properties.forEach(function (property) {
      let cssProp = property.split(':');
      let cssKey = cssProp[0].trim();
      let cssValue = cssProp[1].trim();
      frameCSSObj[cssKey] = cssValue;
    });
    return frameCSSObj;
  }
}

// Change element parent for edit mode outside moveable target
function changeParent(pageId, selectedItem) {
  // Set for while loop limit
  let i = 0;

  if (selectedItem.type === 'Text') {
    // Find Draft Component holder to change parent for active edit mode
    const changeElement = document.getElementById(`E${selectedItem.targetId}`);

    // Set change element & element holder as global for revers
    this.changeElementHolder = selectedItem.target;
    this.changeElement = changeElement;

    // check and set for fix width
    const holderWidth = _.get(this.changeElementHolder, 'style.width');
    if (!holderWidth) {
      this.changeElementHolder.dataset.notFix = 'true';
    }

    // Set Moveable target styles to change element
    this.changeElement.style.transform = this.selectedElement.target.style.transform;
    this.changeElement.style.width = this.selectedElement.target.style.width;
    this.selectedElement.target.style.width = this.changeElement.offsetWidth + 'px';
    this.selectedElement.target.style.height = this.changeElement.offsetHeight + 'px';
    // this.changeElement.style.cssText = this.selectedElement.target.style.cssText;

    // Change element parent to editable box and set editable mode
    this.editableMode = true;
    let editableBox = document.getElementById(`artboardContainer_${pageId}`);
    editableBox.appendChild(changeElement);
    this.editableMode = true;
  }
}

// Reverse changeParent function
function changeReverse() {
  if (!this.editableMode) return;
  if (this.changeElement) {
    this.editable = 0;
    this.editableMode = false;
    this.changeElement.style.cssText = '';
    this.changeElementHolder.appendChild(this.changeElement);
    // this.changeElementHolder.style.cssText = 'width: auto; height: auto;';
    this.changeElement = null;
    this.changeElementHolder.style.height = '';

    // check and set for data-not-fix and set holder width
    if (this.changeElementHolder.dataset.notFix === 'true') {
      this.changeElementHolder.style.width = '';
    }
  }
  return 'Change reverse complete';
}

function exitCropMode() {
  this.props.changeEditMode(-1, false);
  this.cropCover.remove();
  this.imgShadow.remove();
  this.cropLinesBox.remove();
  const wpCover = document.querySelector('.wpCover');
  wpCover.classList.remove('cropMode');
  this.selectedElement.target && this.selectedElement.target.classList.remove('onCrop');
  this.selectedElement.type = convertId(this.selectedElement.targetId).type;
  this.setImg(this.state.target);
  this.editableMode = false;

  // For Deselect all (its better change to select main media)
  this.setState(
    {
      target: null,
      targets: null,
    },
    () => {
      this.props.onSelectEntity(null);
      this.props.showColorPicker(false);
      this.props.showFilterPanel(false);
      this.props.enableEditor(null);
    },
  );
}

// Show Video controller
function videoController(page, target, targetId) {
  const activeController = document.querySelector(
    `#artboardContainer_${page} .moveable-control-box .controller`,
  );
  if (activeController) {
    if (activeController.dataset.id !== `vc_${targetId}`) {
      activeController.style.display = 'none';
      this.activeControlTarget.appendChild(activeController);
    } else {
      videoControllerElements(page, target);
      return;
    }
  }
  this.activeControlTarget = target;
  const controller = target.querySelector('.controller');
  const container = document.querySelector(`#artboardContainer_${page} .moveable-control-box`);
  if (controller) {
    container.appendChild(controller);
    videoControllerElements(page, target);
  }
}

//Set controller elements position
function videoControllerElements(page, target) {
  // target =
  //   target && target
  //     ? target
  //     : document.querySelector(`#artboardContainer_${page} .moveable-control-box .controller`);
  let controller = document.querySelector(
    `#artboardContainer_${page} .moveable-control-box .controller`,
  );
  if (!controller) {
    return;
  }
  controller.style.display = 'block';
  controller.style.width = target.style.width;
  controller.style.height = target.style.height;
  const playBtn = controller.querySelector('.playBtn');
  playBtn.style.marginTop = parseInt(target.style.height) / 2 - 75 + 'px';
  playBtn.style.marginBottom = parseInt(target.style.height) / 2 - 150 + 'px';
  const slider = controller.querySelector('.input-range');
}

function aPoint(el, transform) {
  const b = el.offsetWidth;
  const width = el.offsetWidth;
  const a = el.offsetHeight;
  const height = el.offsetHeight;
  const angelR = (transform.rotate * Math.PI) / 180;
  const aPoint1 = Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2)) / 2;
  const aPoint2 = Math.asin(b / Math.sqrt(Math.pow(a, 2) / 4 + Math.pow(b, 2))) + angelR;

  const xA = transform.tx + aPoint1 * Math.cos(aPoint2);
  const yA = transform.ty + aPoint1 * Math.sin(aPoint2);
  // let diff1 = { left: new_x - x, top: new_y - y };
  // const xB = (b / 2) * Math.cos(angelR) - (a / 2) * Math.sin(angelR);
  const xB =
    transform.tx + width / 2 + (width / -2) * Math.cos(angelR) - (height / -2) * Math.sin(angelR);
  // const yB = (b / 2) * Math.sin(angelR) + (a / 2) * Math.cos(angelR);
  const yB =
    transform.ty + height / 2 + (width / -2) * Math.sin(angelR) + (height / -2) * Math.cos(angelR);
  const diff = { xA: xA, yA: yA, xB: xB, yB: yB };
  return diff;
}

// Get Transform parameters of element and set to 'currentTransform' array
function getTransform(el, details) {
  if (!el) return;
  let style = window.getComputedStyle(el);
  const currentTransform = {};
  // eslint-disable-next-line no-undef
  let matrix = new WebKitCSSMatrix(style.webkitTransform);

  let angle = Math.round(Math.atan2(matrix.b, matrix.a) * (180 / Math.PI));

  currentTransform.rotate = angle;
  currentTransform.tx = matrix.m41;
  currentTransform.ty = matrix.m42;
  currentTransform.tz = matrix.m43;
  if (currentTransform.tz === 0) currentTransform.tz = 5;
  // currentTransform.sy = Math.sqrt(Math.pow(matrix.a, 2) + Math.pow(matrix.c, 2));
  // currentTransform.sx = Math.sqrt(Math.pow(matrix.b, 2) + Math.pow(matrix.d, 2));
  currentTransform.sx = Math.sqrt(Math.pow(matrix.a, 2) + Math.pow(matrix.b, 2));
  currentTransform.sy = Math.sqrt(Math.pow(matrix.c, 2) + Math.pow(matrix.d, 2));
  const holderW = el.offsetWidth;
  const holderH = el.offsetHeight;

  let childW, childH;
  if (this.selectedElement.holder) {
    childW = this.selectedElement.holder.offsetWidth;
    childH = this.selectedElement.holder.offsetHeight;
  }
  currentTransform.wh = { holderW: holderW, holderH: holderH, childW: childW, childH: childH };
  // cornerA(target, currentTransform)
  // ** NOTE **
  // that the result of scale is always positive. If you are also interested in the sign of the scaling
  // (the view is flipped), then the sign of the scaling is the sign of transform.a for x flip and transform.d
  // for y flip. One way to inherit the sign.
  // scaleX = (matrix.a/Math.abs(matrix.a)) * Math.sqrt(Math.pow(matrix.a, 2) + Math.pow(matrix.c, 2))
  // scaleY = (matrix.d/Math.abs(matrix.d)) * Math.sqrt(Math.pow(matrix.b, 2) + Math.pow(matrix.d, 2))
  if (details) {
    return currentTransform;
  } else {
    this.currentTransform = currentTransform;
    return this.currentTransform;
  }
}

// Set 'currentTransform' array to element transform parameters
// this function not used in Moveable
function setTransform(el, transform) {
  el.style.transform = `translateZ(${transform.tz}px) translateX(${transform.tx}px) translateY(${transform.ty}px) rotate(${transform.rotate}deg) scaleX(${transform.sx}) scaleY(${transform.sy})`;
}

// Get Aspect ratio of moveable image
function imageRatio(el) {
  let type;
  let img = el.getElementsByTagName('img')[0];
  if (!img) {
    img = el.getElementsByTagName('video')[0];
    if (!img) {
      img = el.getElementsByTagName('svg')[0];
    } else {
      type = 'video';
    }
  }
  if (img) {
    this.selectedImage.holder = el.querySelector('.holder');
    this.selectedImage.holderW = parseInt(_.get(this.selectedImage, 'holder.style.width', 0));
    this.selectedImage.holderH = parseInt(_.get(this.selectedImage, 'holder.offsetHeight', 0));
    this.selectedImage.image = img.src;
    // Get Image original size and return aspect ratio
    if (type === 'video') {
      return img.videoWidth / img.videoHeight;
    } else {
      return img.naturalWidth / img.naturalHeight;
    }
  }
}

function deselectAll(event) {
  if (
    this.wrapperRef &&
    !this.wrapperRef.contains(event.target) &&
    event.target.className === 'artboardHolder'
  ) {
    this.changeReverse();
    // clicked outside of artboardContainer
    this.setState(
      {
        target: null,
      },
      () => { },
    );
  } else {
    // clicked inside of artboardContainer
  }
}

const moveableBoarder = scale => {
  // let lines = [...document.querySelectorAll('.moveable-line')];
  // let controls = [...document.querySelectorAll('.moveable-control')];
  // let newH, newC;
  // if (scale < 100) {
  //   newH = (2 / scale) * 100;
  //   newC = (12 / scale) * 100;
  // } else {
  //   newH = 2 / (scale / 100);
  //   newC = 12 / (scale / 100);
  // }
  // lines.map(line => {
  //   line.style.height = `${newH}px`;
  // });
  // controls.map(control => {
  //   if (control.dataset.direction) {
  //     control.style.borderWidth = `${newH}px`;
  //   } else {
  //     control.style.borderWidth = `${newH * 2}px`;
  //   }
  //   control.style.height = `${newC}px`;
  //   control.style.width = `${newC}px`;
  //   control.style.marginTop = `${-(newC / 2)}px`;
  //   control.style.marginLeft = `${-(newC / 2)}px`;
  // });
  // let controlBoxes = [...document.querySelectorAll('.moveable-control-box')];
  let artboardHolder = document.getElementById('artboardHolder');
  // controlBoxes.map(controlBox => {
  // artboardHolder.style.setProperty('--zoompx', `${1 / (scale / 100)}px`);
  artboardHolder.style.setProperty('--zoompx', `${1}px`);
  // });
};

const convertId = targetId => {
  const typeMap = {
    B: 'Background',
    C: 'CropMode',
    F: 'Frame',
    G: 'Grid',
    L: 'Line',
    P: 'Image',
    S: 'Shape',
    T: 'Text',
    V: 'Vector',
  };
  const targetIdType = {};
  if (_.has(targetId, 'id')) {
    const letter = _.findKey(typeMap, function (type) {
      return type === targetId.type;
    });
    targetIdType.targetId = `${letter}_${targetId.id}`;
    targetIdType.id = targetId.id;
    targetIdType.type = targetId.type;
  } else {
    const id = parseInt(targetId.split('_')[1]);
    const type = typeMap[targetId.split('_')[0]];
    targetIdType.id = id;
    targetIdType.type = type;
    targetIdType.targetId = targetId;
  }
  return {
    id: targetIdType.id,
    type: targetIdType.type,
    targetId: targetIdType.targetId,
  };
};

const setType = targetType => {
  switch (targetType) {
    case 'Text':
      return {
        type: 'Text',
        config: {
          isResizable: false,
          isScalable: true,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'ne', 'e', 'se', 'sw', 'w'],
      };
    case 'Image':
      return {
        type: 'Image',
        config: {
          isResizable: true,
          isScalable: false,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'],
      };
    case 'Shape':
      return {
        type: 'Shape',
        config: {
          isResizable: false,
          isScalable: true,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'],
      };
    case 'Grid':
      return {
        type: 'Grid',
        config: {
          isResizable: false,
          isScalable: true,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'n', 'ne', 'e', 'se', 's', 'sw', 'w'],
      };
    case 'Line':
      return {
        type: 'Line',
        config: {
          isResizable: true,
          isScalable: false,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['e', 'w'],
      };
    case 'Vector':
      return {
        type: 'Vector',
        config: {
          isResizable: false,
          isScalable: true,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'ne', 'se', 'sw'],
      };
    case 'Frame':
      return {
        type: 'Frame',
        config: {
          isResizable: false,
          isScalable: true,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'ne', 'se', 'sw'],
      };
    case 'Group':
      return {
        type: 'Group',
        config: {
          isResizable: false,
          isScalable: true,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'ne', 'se', 'sw'],
      };
    case 'Background':
      return {
        type: 'Background',
        config: {
          isResizable: false,
          isScalable: false,
          isRotatable: false,
          isDraggable: false,
        },
        renderDir: [],
      };
    case 'CropMode':
      return {
        type: 'CropMode',
        config: {
          isResizable: true,
          isScalable: false,
          isRotatable: true,
          isDraggable: true,
        },
        renderDir: ['nw', 'ne', 'se', 'sw'],
      };
  }
};

function cursor(pageId, rotate) {
  let classNumber = Math.round(rotate / 15);
  if (classNumber < 0) {
    classNumber = 24 + classNumber;
  }
  while (classNumber > 24) {
    classNumber -= 24;
  }
  if (classNumber === 24) {
    classNumber = 0;
  }
  this.elementRotate = classNumber;
}

// Calculate actual position of corner A (top,left)
function cornerA(currentTransform) {
  const xM = parseFloat(currentTransform.tx);
  const yM = parseFloat(currentTransform.ty);
  const rM = currentTransform.rotate;
  const sM = currentTransform.sx;
  const rotate = (rM * Math.PI) / 180;
  const width = currentTransform.wh.childW;
  const height = currentTransform.wh.childH;
  const xA =
    parseFloat(xM + width / 2 + (width / -2) * (Math.cos(rotate) * sM)) -
    (height / -2) * (Math.sin(rotate) * sM);
  const yA =
    yM +
    height / 2 +
    (width / -2) * (Math.sin(rotate) * sM) +
    (height / -2) * (Math.cos(rotate) * sM);

  return { x: xM, y: yM, xA: xA, yA: yA, rM: rM, sM: sM };
}

// Get old position of 'A' corner position and caculate move pixels after
// calculate new actual position and set to entity
function entityNewPos(target, targetHolder, oldAPos, currentTransform) {
  targetHolder.style.height = target.offsetHeight + 'px';
  const newAPos = cornerA(currentTransform);
  const xDiff = newAPos.xA - oldAPos.xA;
  const yDiff = newAPos.yA - oldAPos.yA;
  const newX = parseFloat(newAPos.x - xDiff).toFixed(4);
  const newY = parseFloat(newAPos.y - yDiff).toFixed(4);
  if (target) {
    const transform = `translateZ(5px) translateX(${newX}px) translateY(${newY}px) rotate(${newAPos.rM}deg) scaleX(${newAPos.sM}) scaleY(${newAPos.sM})`;
    targetHolder.style.transform = transform;
    if (target.style.transform) {
      target.style.transform = transform;
    }
  } else {
    return {
      tx: newX,
      ty: newY,
      rotate: newAPos.rM,
      scale: newAPos.sM,
    };
  }
}

function matrixAnalyze(el) {
  if (!el) return;
  let style = window.getComputedStyle(el);
  // eslint-disable-next-line no-undef
  let matrix = new WebKitCSSMatrix(style.webkitTransform);

  let angle = Math.round(Math.atan2(matrix.b, matrix.a) * (180 / Math.PI));
  let sx = Math.sqrt(Math.pow(matrix.a, 2) + Math.pow(matrix.c, 2));
  let sy = Math.sqrt(Math.pow(matrix.b, 2) + Math.pow(matrix.d, 2));

  let transform = { tx: matrix.m41, ty: matrix.m42, tz: matrix.m43, rotate: angle, sx: sx, sy: sy };

  return transform;
}

// Move elements with arrow keys
function stepMove(targets, steps, direction) {
  targets.map(target => {
    let targetTransform = matrixAnalyze(target);
    switch (direction) {
      case 'left':
        targetTransform.tx -= steps;
        break;
      case 'up':
        targetTransform.ty -= steps;
        break;
      case 'right':
        targetTransform.tx += steps;
        break;
      case 'down':
        targetTransform.ty += steps;
        break;
    }
    setTransform(target, targetTransform);
  });
}

//Set video controller rotation
const controllerUpdate = (page, target, opacity) => {
  const rRegex = /(?:rotate\()([a-z0-9.-]+)/;
  const controller = document.getElementById(`vController`);
  const controlBox = document.querySelector(`#artboardContainer_${page} .moveable-control-box `);
  const nwHandler = controlBox.querySelector('.moveable-nw');
  const rotateHandler = controlBox.querySelector('.moveable-rotation-line');
  if (!nwHandler || !controller || !rotateHandler) return;
  videoControllerElements(page, target);
  const tM = nwHandler.style.transform;
  const rM = rRegex.exec(rotateHandler.style.transform)[1];
  controller.style.transform = `${tM} rotate(${rM})`;
  controller.style.opacity = opacity;
};

export {
  CSS2JS,
  changeParent,
  changeReverse,
  aPoint,
  getTransform,
  imageRatio,
  setTransform,
  deselectAll,
  moveableBoarder,
  setType,
  cursor,
  videoController,
  videoControllerElements,
  convertId,
  exitCropMode,
  cornerA,
  entityNewPos,
  stepMove,
  matrixAnalyze,
  controllerUpdate,
};
